export default "__VITE_ASSET__Crm3j3rf__"